export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Share progress on both frontend and backend tasks', frequency: 'Daily at 9 AM' },
      { name: 'Code Reviews', description: 'Review full-stack PRs with focus on integration', process: 'Minimum 2 approvals for full-stack changes' },
      { name: 'Sprint Planning', description: 'Plan features across the entire stack', frequency: 'Bi-weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Team communication', channels: ['#fullstack-team', '#frontend', '#backend'] },
      { name: 'Jira', purpose: 'Task tracking', access: 'Developer role with full-stack labels' },
      { name: 'GitHub', purpose: 'Code collaboration', permissions: 'Read/Write on frontend and backend repos' }
    ],
    processes: [
      { name: 'Feature Development', steps: ['Design API contract', 'Implement backend', 'Build frontend', 'Integration testing'] },
      { name: 'Bug Triage', steps: ['Identify stack layer', 'Reproduce across stack', 'Fix root cause', 'Test end-to-end'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Architecture Reviews', description: 'Review full-stack architecture decisions', frequency: 'Weekly' },
      { name: 'Cross-team Coordination', description: 'Coordinate with frontend and backend specialists', commitment: 'Bridge communication gaps' },
      { name: 'Performance Optimization', description: 'Optimize across the entire stack', scope: 'End-to-end performance' }
    ],
    tools: [
      { name: 'Confluence', purpose: 'Architecture documentation', access: 'Editor for full-stack docs' },
      { name: 'New Relic', purpose: 'Full-stack monitoring', access: 'Read/Write dashboards' },
      { name: 'Sentry', purpose: 'Error tracking across stack', access: 'Team admin' }
    ],
    processes: [
      { name: 'Integration Testing', steps: ['API contract testing', 'End-to-end testing', 'Performance testing', 'Security testing'] },
      { name: 'Deployment Pipeline', steps: ['Build frontend', 'Build backend', 'Integration tests', 'Staged deployment'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Technical Leadership', description: 'Lead full-stack architecture decisions', responsibility: 'End-to-end system design' },
      { name: 'Team Mentoring', description: 'Mentor both frontend and backend developers', scope: 'Cross-functional guidance' },
      { name: 'Strategic Planning', description: 'Plan full-stack technology roadmap', impact: 'Company-wide architecture' }
    ],
    tools: [
      { name: 'AWS Console', purpose: 'Full infrastructure management', access: 'Admin permissions' },
      { name: 'Datadog', purpose: 'Comprehensive monitoring', role: 'Platform admin' },
      { name: 'GitHub Enterprise', purpose: 'Repository management', access: 'Org admin' }
    ],
    processes: [
      { name: 'System Design', steps: ['Requirements analysis', 'Architecture design', 'Technology selection', 'Implementation planning'] },
      { name: 'Scalability Planning', steps: ['Performance analysis', 'Bottleneck identification', 'Scaling strategy', 'Implementation roadmap'] }
    ]
  }
};
